export const links = {
  linkedIn: 'https://www.linkedin.com/company/peslostudios/',
  facebook: 'https://www.facebook.com/peslostudios/',
  twitter: 'https://twitter.com/peslostudios',
  github: 'https://github.com/PesloStudios',
  emailHey: 'mailto:hey@peslostudios.com'
};
